import axios from "axios";
import {
  HotelCfarCancellationPolicyRequest,
  HotelCfarCancelScenario,
} from "redmond";
import { config } from "../../config";
import { getCfarHotelCancellationPath } from "../paths";

export const getCfarHotelCancellationPolicy = async (
  request: HotelCfarCancellationPolicyRequest
): Promise<HotelCfarCancelScenario> => {
  const res = await axios.post(`${getCfarHotelCancellationPath}`, request, {
    baseURL: config.baseURL,
  });

  if (res.data?.Response !== "Success") {
    throw new Error(
      `Failed to fetch hotel CFAR cancellation policy. Errors: ${JSON.stringify(
        res.data?.errors
      )}`
    );
  }

  return res.data.value;
};
